import { DebtMetricCardProps } from '../../types/debt.type';
import customIcons from '../../utils/icons';
import useStreetviewFilterNavigation from '../../hooks/useNavigateUpdateFilters';

interface DebtListCardProps {
  title: string;
  icon: keyof typeof customIcons;
  items: DebtMetricCardProps[];
}

export default function DebtListCard({
  title,
  icon,
  items,
}: DebtListCardProps) {
  const updateFiltersAndRedirect = useStreetviewFilterNavigation();
  const renderListItemValue = (item: DebtMetricCardProps) => {
    const hasFilters = Object.keys(item.filters).length > 0;

    if (hasFilters) {
      return (
        <button
          type="button"
          className="button-green-numerical"
          onClick={() => updateFiltersAndRedirect(item.filters)}
        >
          {item.value}
        </button>
      );
    } return (<span className="min-w-9 text-base font-semibold text-secondary">{item.value}</span>);
  };
  return (
    <div className="flex flex-col items-start gap-5 w-full">
      <div className="flex items-center gap-3 w-full">
        <span className="flex items-center p-2 rounded-full bg-pipgrey-light text-primary text-xl">
          {customIcons[icon]}
        </span>
        <h4 className="text-base font-bold text-secondary">{title}</h4>
      </div>

      <div className="flex flex-col gap-3 w-full">
        {items.map((item) => (
          <div
            key={`${item.value}-${item.label}`}
            className="w-full rounded-md border border-pipgrey-border bg-white px-3 py-3"
          >
            <div className="flex items-center gap-2">
              {renderListItemValue(item)}
              <span className="text-sm font-nunito text-secondary">{item.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
